import { Tooltip } from "antd";
import React from 'react'

function ToolTip({label, children}){
  return  (<Tooltip title={label}>{children}</Tooltip>)
};
export default ToolTip;
